/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { useEffect, useState } from 'react';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import { activatedeactivate, getAllWebhookConfig, deleteWebhookConfig, sendtestwebhook } from 'src/services/webhookconfigService';
import { Grid, IconButton, Menu, MenuItem } from '@mui/material';
import type { TableColumn } from 'react-data-table-component';
import MUIModal from '../MUIModal/MUIModal';
import AddWebhookForm from './AddWebhookForm';
import EditWebhookForm from './EditWebhookForm';
import GradientButton from '../MUICustomButton/GradientButton';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import { ARE_YOU_SURE, DELETE_WEBHOOK, ACTIVATE_WEBHOOK_SUCCESS_MESSAGE, DEACTIVATE_WEBHOOK_SUCCESS_MESSAGE, DELETE_WEBHOOK_SUCCESS_MESSAGE, WEBHOOK_URL_LIMIT_MESSAGE } from 'src/constants/constant';
import OutlineButton from '../MUICustomButton/OutlineButton';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import type { RootState } from '../types/types';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import {MoreVerticalSolidRounded} from '@hugeicons-pro/core-solid-rounded';
//@ts-ignore
import {MultiplicationSignStrokeStandard} from '@hugeicons-pro/core-stroke-standard';
import type { TooltipProps } from '@mui/material/Tooltip';
import Tooltip, {tooltipClasses } from '@mui/material/Tooltip';
//@ts-ignore
import { Tick02Icon,Cancel01Icon} from "@hugeicons-pro/core-stroke-rounded";
//@ts-ignore
import { PencilEdit02Icon } from '@hugeicons-pro/core-stroke-rounded';
import {checkEventPermission} from "../../common/utility/utility";
import CustomTooltip from '../CustomTooltip/CustomTooltip';


const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} placement="bottom" />
  ))(({ theme }) => ({
      [`& .${tooltipClasses.arrow}`]: {
          color: theme.palette.common.white,
      },
      [`& .${tooltipClasses.tooltip}`]: {
          backgroundColor: theme.palette.common.black,
      },
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const ITEM_HEIGHT = 48;

interface WebhookListPropType {
  "id": number;
  "webhookName": string;
  "clientId": number;
  "url": string;
  "secretKey": string | null;
  "secretValue": string;
  "isDeleted": boolean;
  "isActive": boolean;
  "createdBy": number;
  "createdOn": string;
  "updatedBy": number;
  "updatedOn": string;
  "IncludeTestData": boolean;
}

interface ApiResponse {
  status: number;
  data: {
    data: WebhookListPropType[];
    result: number;
  };
}

interface TestWebhookResponse {
  status: number;
  data: {
    statusCode: number;
    messages: string; 
    result?: number;
  };
}

const WebhookList: React.FC = () => {

  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  const webhookURLCount = JSON.parse(localStorage.getItem("WebhookURLCount") || "0");

  const [webhookListData, setWebhookListData] = useState<WebhookListPropType[]>([])
  const [webhookSearchData, setWebhookSearchData] = useState<WebhookListPropType[]>([])
  const [openAddWebhookModal, setOpenAddWebhookModal] = useState<boolean>(false)
  const [openEditWebhookModal, setOpenEditWebhookModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true)
  const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false)
  const [webhookConfigInfoData, setWebhookConfigInfoData] = useState<any>();
  const [showDeleteWebhookModal, setDeleteWebhookModal] = useState<boolean>(false);
  const [showDeactivateWebhookModal, setDeactivateWebhookModal] = useState<boolean>(false);
  const [showTestWebhookModal, setTestWebhookModal] = useState<boolean>(false);
  const [webhookId, setWebhookId] = useState<number>(0)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [anchorActionEl, setAnchorActionEl] = React.useState<any>({});
  const { user } = useSelector((state: RootState) => state.auth);
  const [showJsonModal, setShowJsonModal] = useState(false);
  const [testwebhook, setTestWebhook] = useState<any>(null); 
  // const [webhookURLCount, setWebhookURLCount] = useState<number>(0);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getWebhookListData()
  }, [user])

  const getWebhookListData = (): void => {
    setLoading(true)
    const ClientId = user?.clientId ?? 0;
    getAllWebhookConfig(ClientId)
    .then(
      (res: ApiResponse) => {
        if (res.status === 200) {
          if(res.data.result === 1) {
          const webhookArr: WebhookListPropType[] = [];
          res.data.data.map((webhook: any) => {
            webhook.Name = `${webhook.webhookName}`
            webhook.IncludeTestData = webhook.includeTestData;
            webhookArr.push(webhook)
          })
          setWebhookListData(webhookArr)
          setWebhookSearchData(webhookArr)
        } else {
          setWebhookListData([])
          setWebhookSearchData([])
        }
        }
      }
    ) 
    .catch (
      (      error: any) => console.log("Error: ", error)
    )
    .finally(() => {
      setLoading(false)
    })
  }

  const handleAddWebhookClick = (): void => {
    setOpenAddWebhookModal(true)
  }

  const handleCloseAddWebhookModal = (): void => {
    setOpenAddWebhookModal(false)
  }

  const handleEditWebhookClick = (id: number): void => {
    setWebhookId(id);
    setOpenEditWebhookModal(true)
  }

  const handleCloseEditWebhookModal = (): void => {
    setOpenEditWebhookModal(false)
  }

  const handleRefreshPage = (): void => {
    getWebhookListData()
    handleCloseAddWebhookModal()
    handleCloseEditWebhookModal()
  }

  const handleActionClick = (event: React.MouseEvent<HTMLElement>, id: number): void => {
    // anchorActionEl[id] = event.currentTarget
    setAnchorActionEl({ ...anchorActionEl, [id]: event.currentTarget });
  }

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target;
    let webhookDataArr = [...webhookListData]
    if (value !== "") {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-optional-chain
      webhookDataArr = webhookDataArr && webhookDataArr.filter((webhook: WebhookListPropType) => {
        return webhook.webhookName.toLowerCase().search(value.toLowerCase()) >= 0
      })
    }
    setWebhookSearchData(webhookDataArr)
  }

  const handleDeleteWebhook = (id: number, webhookName: string): void => {
      setWebhookConfigInfoData({ id, webhookName });
      setDeleteWebhookModal(true)
      setAnchorActionEl(null);
      setAnchorActionEl({ ...anchorActionEl, [id]: null });
    }
  
    const handleDeleteWebhookClose = ():void => {
      setDeleteWebhookModal(false)
    }
  
    const handleDeleteWebhookConfirm = ():void => {
      setIsModalSaveLoading(true)
  
    const { id } = webhookConfigInfoData;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const userData = JSON.parse(localStorage.getItem("user"))
      
      const data = {
        "updatedBy": userData.id,
        "webhookIdList": [
          {
            "id": id
          }
        ],
      }
  
      deleteWebhookConfig(data)
        .then(
          (res: ApiResponse) => {
            if(res.status === 200) {
              if(res.data.result === 1) {
                NotificationManager.success(DELETE_WEBHOOK_SUCCESS_MESSAGE, '', 5000);
                setDeleteWebhookModal(false)
                getWebhookListData()
              }
            }
          }
        )
        .catch((error: any) => console.log("Error", error))
        .finally(() => setIsModalSaveLoading(false))
    }

  const handleactivatedeactivate = (id: number, isActive: boolean, webhookName: string): void => {
    const newIsActive = !isActive;
    setWebhookConfigInfoData({ id, isActive: newIsActive, webhookName });
    setDeactivateWebhookModal(true)
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [id]: null });
  }

  const handleactivatedeactivateClose = ():void => {
      setDeactivateWebhookModal(false)
  }
  
  const handleActivateDeactivateConfirm = ():void => {

    setIsModalSaveLoading(true)

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const userData = JSON.parse(localStorage.getItem("user"))
    const { id, isActive } = webhookConfigInfoData;
    
    const data = {
      "updatedBy": userData.id,
      "webhookIdList": [
        {
          "id": id
        }
      ],
      "activeOrDeActive": (Boolean((webhookConfigInfoData?.isActive))) ? 1 : 0
    }

    activatedeactivate(data)
      .then(
        (res: ApiResponse) => {
          if(res.status === 200) {
            if(res.data.result === 1) {
              if (Boolean(isActive)) {
                NotificationManager.success(ACTIVATE_WEBHOOK_SUCCESS_MESSAGE, '', 5000);
              } else {
                NotificationManager.success(DEACTIVATE_WEBHOOK_SUCCESS_MESSAGE, '', 5000);
                // Adjust the width inline
                setTimeout(() => {
                  const notification = document.querySelector('.notification-container') as HTMLElement | null;
                  if (notification !== null) {
                    notification.style.width = '340px'; // Set your desired width
                  }
                }, 0);
              }
              setDeactivateWebhookModal(false)
              getWebhookListData()
            }
          }
        }
      )
      .catch((error: any) => console.log("Error", error))
      .finally(() => setIsModalSaveLoading(false))
  }

  const handleJsonModalClose = ():void => {
    setShowJsonModal(false);
  }

  const handleTestWebhook = (id: number, clientId: number, webhookName: string): void => {
    setWebhookConfigInfoData({ id, clientId, webhookName });
    setTestWebhookModal(true)
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [id]: null });
  }

  const handleTestWebhookClose = ():void => {
    setTestWebhookModal(false)
  }

  const handleTestWebhookConfirm = (): void => {
    setIsModalSaveLoading(true);
  
    try {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const userData = JSON.parse(localStorage.getItem("user"))
      const { id, clientId } = webhookConfigInfoData;
  
      sendtestwebhook(id, clientId, userData.id)
        .then((res: TestWebhookResponse) => {
          // Always store the response, whether success or failure
          const responseToShow = {
            statusCode: res.data.statusCode,
            messages: res.data.messages,
          };
  
          setTestWebhook(responseToShow);
          
          if (res.status === 200) {
            try {
              const messageData = JSON.parse(res.data.messages);
              if (messageData.status?.toLowerCase().includes("success")) {
                NotificationManager.success("Webhook test initiated successfully!", "", 5000);
                setTestWebhookModal(false);
                setTimeout(() => setShowJsonModal(true), 300);
              } else {
                NotificationManager.error(messageData.message || "Webhook test failed", "Error");
                setTestWebhookModal(false);
                setTimeout(() => setShowJsonModal(true), 300); // Show modal for failed cases too
              }
            } catch (parseError) {
              console.error("Error parsing webhook response:", parseError);
              NotificationManager.error("Failed to parse webhook test response", "Error");
              setTestWebhookModal(false);
              setTimeout(() => setShowJsonModal(true), 300); // Show modal with raw response
            }
          } else {
            NotificationManager.error("Webhook test failed", "Error");
            setTestWebhookModal(false);
            setTimeout(() => setShowJsonModal(true), 300); // Show modal with error response
          }
        })
        .catch((error: any) => {
          console.error("Error testing webhook:", error);
          // Create a response object from the error if available
          const errorResponse = error.response?.data || {
            statusCode: error.status || 500,
            messages: error.message || "Unknown error occurred"
          };
          setTestWebhook(errorResponse);
          NotificationManager.error("Webhook test failed", "Error");
          setTestWebhookModal(false);
          setTimeout(() => setShowJsonModal(true), 300);
        })
        .finally(() => setIsModalSaveLoading(false));
    } catch (localStorageError) {
      console.error("Error accessing localStorage:", localStorageError);
      setIsModalSaveLoading(false);
      NotificationManager.error("Failed to access user data", "Error");
      setTestWebhookModal(false);
    }
  };

  const formatApiResponseForDisplay = (response: any): string => {
    const jsonString = JSON.stringify(response, (key, value) => {
      // Skip the parsedMessages field as we display it separately
      if (key === 'parsedMessages') return undefined;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return value;
    }, 2);
  
    // Highlight status codes and important fields
    return jsonString
      .replace(
        /"statusCode": (\d+)/,
        (match, statusCode) => `"statusCode": <span style="color: ${statusCode === '200' ? 'green' : 'red'}; font-weight: bold">${statusCode}</span>`
      )
      .replace(
        /"status": "(\w+)"/,
        (match, status) => `"status": <span style="color: ${status === 'Success' ? 'green' : 'red'}; font-weight: bold">"${status}"</span>`
      )
      .replace(
        /"messages": "([^"]*)"/,
        (match, messages) => {
          // Escape HTML tags in messages
          const escapedMessages = messages
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
          return `"messages": <span style="color: ${response.statusCode === 200 ? 'inherit' : 'red'}">"${escapedMessages}"</span>`;
        }
      );
  };

  const statusTexts = {
    200: "OK",
    400: "Bad Request",
    401: "Unauthorized",
    403: "Forbidden",
    404: "Not Found",
    405: "Method Not Allowed",
    408: "Request Timeout",
    500: "Internal Server Error",
    502: "Bad Gateway",
    503: "Service Unavailable",
    504: "Gateway Timeout",
  };


  const columns: TableColumn<WebhookListPropType>[] = [
    {
      name: 'Name',
      selector: (row: WebhookListPropType) => row.webhookName,
      cell: (row: WebhookListPropType) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
            <div className="overflow-hidden" style={{ width: '100%' }}>
              <p className="text-14 text-muted">{row.webhookName}</p>
            </div>
          </div>
        )
      },
      width: '25%',
      sortable: true
    },
    {
      name: 'URL',
      selector: (row: WebhookListPropType) => row.url,
      width: '40%',
      wrap: true,
      sortable: true,
      cell: (row: WebhookListPropType) => (
          <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>   
              <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted" style={{ width: '100%' }}>
                  <CustomTooltip title={row.url} placement="bottom" arrow={false}>
                    <p className='overflow-hidden text-ellipsis whitespace-nowrap w-full'>{row.url}</p>
                  </CustomTooltip>
              </div>
          </div>
      )
    },
    {
      name: 'Status',
      sortable: false,
      width: "10%",
      // selector: row => row.year,
      cell: (row: WebhookListPropType) => {
        return row.isActive ? <div className="badge truncate" style={{
          background: '#CCFFEA',
          padding: '10px 15px',
          color: '#06A864',
          border: '0px'
        }}>Active</div> : <div className="badge truncate" style={{
          background: '#FFF5F6',
          padding: '10px 15px',
          color: '#F13139',
          border: '0px'
        }}>Inactive</div>
      },
      center: true,
    },
    {
      name: 'Include Test Data',
      selector: (row: WebhookListPropType) => row.IncludeTestData,
      width: '15%',
      sortable: true,
      cell: (row: WebhookListPropType) => (
        <span className="text-14 text-muted">
          {row.IncludeTestData ? 'Yes' : 'No'}
        </span>
      ),
    },
    {
      name: 'Actions',
      // selector: (row: any) => row.role,
      cell: (row: WebhookListPropType) => {
        console.log("anchorActionEl", anchorActionEl)
        return (
          <div className='flex items-center'>
            <div onClick={() => handleEditWebhookClick(row.id)} className="icon-hover-container">
              <HugeiconsIcon
                              icon={PencilEdit02Icon}
                              size={20}
                              color="#3A3A3A"
                              strokeWidth={0.2}
                            />
            </div>
            {(checkEventPermission("WEBHOOKS_ACTIVATE") ||  checkEventPermission("WEBHOOKS_DELETE") || checkEventPermission("WEBHOOKS_TEST") ) && (
            <div className='flex'>
              <IconButton
                aria-label="more"
                id="long-button"
                // aria-controls={open ? 'long-menu' : undefined}
                // aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={(e) => handleActionClick(e, row.id)}
              >
               <HugeiconsIcon
               icon={MoreVerticalSolidRounded}
               size={24}
               color="#3A3A3A"
               strokeWidth={0.2}
                 />
              </IconButton>
              <Menu
                id={`${row.id}`}
                className='table-action-menu'
                MenuListProps={{
                  'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorActionEl[row.id]}
                open={Boolean(anchorActionEl[row.id])}
                onClose={() => setAnchorActionEl({ ...anchorActionEl, [row.id]: null })}
               slotProps={{ paper: {
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: '18ch',
                  },
                }}}
              >
                 {checkEventPermission("WEBHOOKS_ACTIVATE") &&
                <MenuItem onClick={() => handleactivatedeactivate(row.id, row.isActive, row.webhookName)}>
                <span style={{ paddingLeft: '15px' }} className='text-muted font-normal'>{row.isActive ? "Deactivate" : "Activate"}</span>
                </MenuItem>
                }
                {checkEventPermission("WEBHOOKS_DELETE") &&
                <MenuItem onClick={() => handleDeleteWebhook(row.id, row.webhookName)}>
                  <span style={{ paddingLeft: '15px', color: '#F13139' }}>Delete</span>
                </MenuItem>
                }
                {checkEventPermission("WEBHOOKS_TEST") && (<CustomTooltip title={!row.isActive ? "Activate webhook to test" : ""}>
                <MenuItem disabled={!row.isActive} onClick={() => handleTestWebhook(row.id, row.clientId, row.webhookName)}>
                 <span style={{ paddingLeft: '15px' }} className='text-muted font-normal'>Test webhook</span>
                </MenuItem>
                </CustomTooltip>
                )}
              </Menu>
            </div>
           )}
          </div>
        )
      },
      width: '10%',
      sortable: false,
      center: true,
    },

  ]

  return (
    <>
      <h2 className="text-2xl font-semibold text-title">Manage Webhooks</h2>
      <div className="mt-[20px] mb-[20px] live-outreach-container">
        <Grid container spacing={2} alignItems={'center'}>
          <Grid item xs={12} sm={6} md={6} lg={4}>
            <div className="w-full">
              <input
                type="text"
                placeholder="Search by name"
                className="input input-bordered search-input-white focus:ring-0 focus:outline-none border-[#E6ECF2] font-normal text-14 text-muted w-full"
                onChange={handleSearch}
              />
            </div>
          </Grid>
          <Grid item xs={6} md={6} lg={8} className='bulk-action flex justify-end'>
            {checkEventPermission("WEBHOOKS_ADD") &&
              <BootstrapTooltip title={webhookListData.length >= parseInt(webhookURLCount.configValue) ? WEBHOOK_URL_LIMIT_MESSAGE : ""} arrow>
                <span>
                  <GradientButton color='red' onClick={handleAddWebhookClick} disabled={webhookListData.length >= parseInt(webhookURLCount.configValue)}>
                    <span style={{
                      width: "20px",
                      height: "20px",
                      background: "#fff",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "50px",
                      marginRight: "5px"
                    }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                        <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                        <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
                      </svg>
                    </span>
                    Add New Webhook
                  </GradientButton>
                </span>
              </BootstrapTooltip>
            }
          </Grid>
        </Grid>
      </div>
      
      <div className='data-table-container mb-10 te-table-container'>
        <CustomDataTable
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          columns={columns}
          data={webhookSearchData}
          pagination
          // selectableRows
          progressPending={loading}
        />

        <MUIModal title='New Webhook' openModal={openAddWebhookModal} closeModal={handleCloseAddWebhookModal} width={'50%'} >
          <AddWebhookForm closeModal={handleCloseAddWebhookModal} refreshPage={handleRefreshPage} />
        </MUIModal>
        <MUIModal title='Edit Webhook' openModal={openEditWebhookModal} closeModal={handleCloseEditWebhookModal} width={'50%'} >
          <EditWebhookForm closeModal={handleCloseEditWebhookModal} refreshPage={handleRefreshPage} id = {webhookId}/>
        </MUIModal>

        <BootstrapDialog
        onClose={handleDeleteWebhookClose}
        aria-labelledby="customized-dialog-title"
        open={showDeleteWebhookModal}
        PaperProps={{
          sx: {
            width: '550px',
            height: '200px'
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
          Delete Webhook
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleDeleteWebhookClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <HugeiconsIcon
          icon={MultiplicationSignStrokeStandard}
          size={24}
          color="currentcolor"
          strokeWidth={0.5}
          /> 
        </IconButton>
        <DialogContent>
          <p className='text-14 text-muted'>{ARE_YOU_SURE} {DELETE_WEBHOOK} <span className='font-semibold'>{webhookConfigInfoData?.webhookName}</span>?</p>
        </DialogContent>
        <DialogActions sx={{ background: '#F9F9F9' }}>

          <OutlineButton color='gray' onClick={handleDeleteWebhookClose} width='100px'>Cancel</OutlineButton>

          <GradientButton type='button' color='red' onClick={handleDeleteWebhookConfirm} width='100px'>{!isModalSaveLoading ? 'Delete' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
        </DialogActions>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleactivatedeactivateClose}
        aria-labelledby="customized-dialog-title"
        open={showDeactivateWebhookModal}
        PaperProps={{
          sx: {
            width: '550px',
            height: '200px'
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
          {(Boolean((webhookConfigInfoData?.isActive))) ? "Activate Webhook" : "Deactivate Webhook"}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleactivatedeactivateClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <HugeiconsIcon
          icon={MultiplicationSignStrokeStandard}
          size={24}
          color="currentcolor"
          strokeWidth={0.5}
          /> 
        </IconButton>
        <DialogContent>
          <p className='text-14 text-muted'>{ARE_YOU_SURE} {(Boolean((webhookConfigInfoData?.isActive))) ? "activate the webhook" : "deactivate the webhook"} <span className='font-semibold'>{webhookConfigInfoData?.webhookName}</span>?</p>
        </DialogContent>
        <DialogActions sx={{ background: '#F9F9F9' }}>

          <OutlineButton color='gray' onClick={handleactivatedeactivateClose} width='130px'>Cancel</OutlineButton>

          <GradientButton type='button' color='red' onClick={handleActivateDeactivateConfirm} width='130px'>{!isModalSaveLoading ? ((Boolean((webhookConfigInfoData?.isActive))) ? "Activate" : "Deactivate") : (<span className="loading loading-spinner loading-xs text-white"></span>)}</GradientButton>
        </DialogActions>
      </BootstrapDialog>

      <BootstrapDialog onClose={handleTestWebhookClose} aria-labelledby="customized-dialog-title" open={showTestWebhookModal} PaperProps={{sx: {width: '550px',height: '200px'},}}>
        <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
          Test webhook
        </DialogTitle>
        <IconButton aria-label="close" onClick={handleTestWebhookClose} sx={{ position: 'absolute',right: 8,top: 8,color: (theme) => theme.palette.grey[500],}}>
          <HugeiconsIcon
          icon={MultiplicationSignStrokeStandard}
          size={24}
          color="currentcolor"
          strokeWidth={0.5}
          /> 
        </IconButton>
        <DialogContent>
          <p className='text-14 text-muted'>{ARE_YOU_SURE} {"test webhook "} <span className='font-semibold'>{webhookConfigInfoData?.webhookName}</span>?</p>
        </DialogContent>
        <DialogActions sx={{ background: '#F9F9F9' }}>

          <OutlineButton color='gray' onClick={handleTestWebhookClose} width='130px'>No</OutlineButton>

          <GradientButton type='button' color='red' onClick={handleTestWebhookConfirm} width='100px'>{!isModalSaveLoading ? 'Yes' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
        </DialogActions>
      </BootstrapDialog>

      <BootstrapDialog onClose={handleJsonModalClose} aria-labelledby="json-dialog-title" open={showJsonModal} PaperProps={{ sx: { width: '600px', height: '300px' } }}>
        <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }}>
          Webhook Response
        </DialogTitle>

        <IconButton aria-label="close" onClick={handleJsonModalClose} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}>
          <HugeiconsIcon icon={MultiplicationSignStrokeStandard} size={24} color="currentcolor" strokeWidth={0.5} />
        </IconButton>

        <DialogContent sx={{ maxHeight: '250px', overflow: 'auto', padding: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px', padding: '5px', fontSize: '14px', fontWeight: 'bold', color: testwebhook?.statusCode === 200 ? '#06A864' : '#ED4B52' }}>
            Status Code: {testwebhook?.statusCode} {testwebhook?.statusCode && statusTexts[testwebhook.statusCode as keyof typeof statusTexts] ? statusTexts[testwebhook.statusCode as keyof typeof statusTexts] : ''}
            <HugeiconsIcon icon={testwebhook?.statusCode === 200 ? Tick02Icon : Cancel01Icon} size={18} strokeWidth={0.2} />
          </div>
          <div style={{ background: '#f4f4f4', padding: '10px', borderRadius: '5px', whiteSpace: 'pre-wrap', maxHeight: '230px', overflowY: 'auto', overflowX: 'hidden', fontFamily: 'monospace', wordBreak: 'break-word' }}>
            {testwebhook?.messages ? (<div dangerouslySetInnerHTML={{ __html: formatApiResponseForDisplay(testwebhook.messages) }} />) : ("No data available")}
          </div>
        </DialogContent>

        <DialogActions sx={{ background: '#F9F9F9' }}>
          <OutlineButton color="gray" onClick={handleJsonModalClose} width="130px">
            Close
          </OutlineButton>
        </DialogActions>
      </BootstrapDialog>
      </div>
    </>
  );
};


export default WebhookList;
